export default "__VITE_PUBLIC_ASSET__cba46131__"